import type { FilterMultiButtonProps } from 'components/Filters/BaseMultiButton'
import FilterRadioGroup from 'components/Filters/FilterRadioGroup'
import { useI18n } from 'context/I18nProvider'

export default function Pathway({ value, onChange, ...props }: FilterMultiButtonProps) {
  const { i18n } = useI18n()

  return (
    <FilterRadioGroup
      value={value ?? null}
      onChange={onChange}
      {...props}
      options={[
        { label: i18n('label.all'), value: null },
        { label: i18n('filtres.freewish.training'), value: 'false' },
        { label: i18n('filtres.freewish.pathway'), value: 'true' },
      ]}
    />
  )
}
